export default `fragment UserErrorFragment on UserError {
  field
  message
}`
